"use client";

import { useTranslations } from "@/app/(site)/europe/useTranslations";
import Link from "next/link";
import VadImage from "vadimages-nextjs-image-optimizer";

const imageDirectory = `/images/european-lander/`;

export const EuropeanLanderHeroSection = () => {
  const { heroHeadline, heroSubtitle, heroGetSamplesBtn } = useTranslations();

  return (
    <section className="w-full">
      <div className="relative max-w-[1392px] md:mx-6 xl:mx-auto min-h-[600px] md:rounded-default bg-muted-tan">
        {/* Desktop */}
        <div className="hidden md:block absolute top-1/2 -translate-y-1/2 left-4 lg:left-20 z-10">
          <h2 className="max-w-[768px]">{heroHeadline}</h2>
          <p className="max-w-[460px] my-6">{heroSubtitle}</p>
          <Link href="#contact-us" className="btn-yellow-arrow">
            <span>{heroGetSamplesBtn}</span>
          </Link>
        </div>
        {/* Mobile */}
        <div className="text-center px-6 py-8 block md:hidden">
          <h2 className="max-w-[644px] mx-auto">{heroHeadline}</h2>
          <p className="max-w-[460px] my-6 mx-auto">{heroSubtitle}</p>
          <Link href="#contact-us" className="btn-yellow-arrow">
            <span>{heroGetSamplesBtn}</span>
          </Link>
        </div>

        <VadImage
          src={`${imageDirectory}header.png`}
          alt="Hero Image"
          width={1392}
          height={622}
          className="hidden md:block"
        />
        <VadImage
          src={`${imageDirectory}global-facilities.png`}
          alt="Mobile Hero Image"
          width={500}
          height={500}
          className="block md:hidden"
        />
      </div>
    </section>
  );
};
